import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetAllRoundActive } from "../../../../Redux/Reducers/Manager/Dropdowns/GetAllRoundActive";
import AllDropDownsAHSF from "../../../../Components/AllDropDownsAHSF";
import {
  GetAllTransferFromEvaluator,
  GetAllTransferToEvaluator,
} from "../../../../Redux/Reducers/Manager/Dropdowns/GetAllEvaluator";
import { GetAllFieldsByRoundManager } from "../../../../Redux/Reducers/Manager/Dropdowns/GetAllFieldByRound";

function TransferBetweenResidentsDropDown(props) {
  const dispatch = useDispatch();
  const [DropDownRoundActive, setDropDownRoundActive] = useState("");
  const [DropDownFrom, setDropDownFrom] = useState("");
  const [DropDownFields, setDropDownFields] = useState("");

  const [DropDownTo, setDropDownTo] = useState("");

  const state = useSelector((state) => {
    return {
      DropDownRoundActive: state.DropDownRoundActive.DropDownRoundActive,
      DropDownFromEvaluator: state.DropDownEvaluator.DropDownFromEvaluator,
      DropDownToEvaluator: state.DropDownEvaluator.DropDownToEvaluator,
      DropDownFieldsManager: state.DropDownFieldsManager.DropDownFieldsManager,
    };
  });

  useEffect(() => {
    dispatch(GetAllRoundActive());
  }, []);

  useEffect(() => {
    if (DropDownRoundActive) {
      dispatch(
        GetAllFieldsByRoundManager({
          sU_ST_MRI_RoundYearId: parseInt(DropDownRoundActive),
        })
      );
    }
  }, [DropDownRoundActive]);

  useEffect(() => {
    if (DropDownRoundActive && DropDownFields) {
      dispatch(
        GetAllTransferFromEvaluator({
          sU_ST_MRI_RoundYearId: parseInt(DropDownRoundActive),
          fieldId: parseInt(DropDownFields),
        })
      );
    }
  }, [DropDownRoundActive, DropDownFields]);

  useEffect(() => {
    if (DropDownFrom) {
      dispatch(
        GetAllTransferToEvaluator({
          sU_ST_MRI_RoundYearId: parseInt(DropDownRoundActive),
          userId: DropDownFrom,
          fieldId: parseInt(DropDownFields),
        })
      );
    }
  }, [DropDownFrom,DropDownFields]);

  return (
    <>
      <div className="form-grid">
        <AllDropDownsAHSF
          fieldsName="Round"
          show={true}
          arrayOoptionList={state.DropDownRoundActive}
          KeyText={"roundName"}
          KeyValue={"sU_ST_MRI_RoundYearId"}
          dropdownType={"normal"}
          onChange={(e) => {
            setDropDownRoundActive(e.target.value);
            props.setRoundActive(e.target.value);
          }}
        />
        <AllDropDownsAHSF
          fieldsName="FieldManager"
          show={true}
          arrayOoptionList={state.DropDownFieldsManager}
          KeyText={"fieldName"}
          KeyValue={"fieldId"}
          dropdownType={"normal"}
          onChange={(e) => {
            setDropDownFields(e.target.value);
            props.setFields(e.target.value);
            props.setDropDownFrom(null);
            props.setDropDownTo(null);

          }}
        />
        <AllDropDownsAHSF
          // clear={true}
          fieldsName="TransferFromEvaluator"
          show={true}
          arrayOoptionList={state.DropDownFromEvaluator}
          defaultValue={props.DropDownFrom}
          KeyText={"userFullName"}
          KeyValue={"userId"}
          dropdownType={"normal"}
          onChange={(e) => {
            setDropDownFrom(e.target.value);
            props.setDropDownFrom(e.target.value);
            props.setDropDownTo(null);
          }}
        />
        <AllDropDownsAHSF
          fieldsName="TransferToEvaluator"
          show={true}
          arrayOoptionList={state.DropDownToEvaluator}
          defaultValue={props.DropDownTo}
          KeyText={"userFullName"}
          KeyValue={"userId"}
          dropdownType={"normal"}
          onChange={(e) => {
            setDropDownTo(e.target.value);
            props.setDropDownTo(e.target.value);
          }}
        />
      </div>
      
    </>
  );
}

export default TransferBetweenResidentsDropDown;
